import React from 'react';
import './App.css';
import TrainBooking from './components/TrainBooking';

function App() {
  return (
    <div className="App">
      <TrainBooking />
    </div>
  );
}

export default App;
